module.exports = __webpack_public_path__ + "static/media/verenaVonBomhard.85d008c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/verenaVonBomhard.jpg
// module id = 1700
// module chunks = 1